import { useDeactivateAccount, useDeleteAccount } from '@/hooks/api/dashboard'
import { useAuth, useLocalStorage } from '@/hooks/common'
import colors from '@/styles/colors'
import { Box, Typography } from '@mui/material'
import { useEffect } from 'react'
import { toast } from 'react-hot-toast'
import { MyProfileDetailsContainer } from '../__styled'
import AccountManagement from './AccountManagement'
import Subscription from './Subscription'
import MediaView from './MediaView'
import { RBox } from '@/pages/__styled'
import { useNavigate } from 'react-router-dom'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'

export default function MyProfileDetails() {
  const [ewUser] = useLocalStorage('ewUser', null)
  const deactivate = useDeactivateAccount(ewUser?.userID)
  const deleteAccount = useDeleteAccount(ewUser?.userID)
  const [myDMConnections] = useAppStore((state) => [state.user.myDMConnections], shallow)
  const { logout, basicInfo } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (deactivate.isSuccess || deleteAccount.isSuccess) {
      logout()
    }
  }, [deactivate.isSuccess, deleteAccount.isSuccess])

  const onSubmitDeactivateAccount = () => {
    toast.promise(deactivate.mutateAsync(), {
      loading: 'Deactivating your account',
      success: <Typography variant='p'>Profile has been deactivated.</Typography>,
      error: <Typography variant='p'>Failed to deactivate your account.</Typography>,
    })
  }

  const onSubmitDeleteAccount = () => {
    toast.promise(deleteAccount.mutateAsync(), {
      loading: 'Deleting your account',
      success: <Typography variant='p'>Profile has been deleted.</Typography>,
      error: <Typography variant='p'>Failed to delete your account.</Typography>,
    })
  }

  const onClickConnections = () => {
    navigate('connections')
  }

  return (
    <Box
      sx={{
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
      }}
    >
      {/* <MediaView /> */}
      <Subscription />
      <Box
        onClick={onClickConnections}
        sx={{
          display: 'flex',
          cursor: 'pointer',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          background: '#ffffff',
          boxShadow:
            '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04), 0 0 0 1px rgba(226, 232, 240, 0.8)',
          border: 'none',
          borderRadius: '16px',
          px: '28px',
          py: '24px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            boxShadow:
              '0 4px 12px rgba(99, 102, 241, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04), 0 0 0 1px rgba(99, 102, 241, 0.15)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: '#0f172a',
            letterSpacing: '-0.02em',
          }}
        >
          {'My Followers'}
        </Typography>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: '#0f172a',
            letterSpacing: '-0.02em',
          }}
        >
          {basicInfo?.connCount || 0}
        </Typography>
      </Box>
      <AccountManagement
        onSubmitDeactivateAccount={onSubmitDeactivateAccount}
        onSubmitDeleteAccount={onSubmitDeleteAccount}
      />
    </Box>
  )
}
